import {
  CompanyTypeEnum,
  CompanyStatusEnum,
} from '@core/models';

export const XEMEX_OID = '00000000-0000-0000-0000-000000000000';

export const COMPANY_USERS_PAGE_SIZE = 10;

export const COMPANY_TYPES = [
  {
    index: CompanyTypeEnum.Customer,
    label: 'companies.filter.partnerType',
  },
  {
    index: CompanyTypeEnum.Installer,
    label: 'companies.filter.installerType',
  },
  {
    index: CompanyTypeEnum.SubInstaller,
    label: 'companies.filter.subInstallerType',
  },
];

export const COMPANY_STATUS = [
  {
    index: CompanyStatusEnum.Active,
    label: 'companies.filter.active',
  },
  {
    index: CompanyStatusEnum.Inactive,
    label: 'companies.filter.inactive',
  },
  {
    index: CompanyStatusEnum.PendingVerification,
    label: 'companies.filter.pendingVerification',
  },
];

export const COUNTRIES = [
  {
    id: 'NL',
    label: 'The Netherlands',
  },
  {
    id: 'BE',
    label: 'Belgium',
  },
  {
    id: 'DE',
    label: 'Germany',
  },
];
